module.exports = __webpack_public_path__ + "assets/84e6eefb0b14ab5cbd479aff24600686.png";